const CONTEST_TITLE = 'Pronto!';

const CONTEST_MESSAGE =
  'Assim que o entregador atualizar essa entrega, avisamos você sobre os próximos passos.';

const BUTTON_CONTEST_SENT = 'OK, entendi';

export { CONTEST_TITLE, CONTEST_MESSAGE, BUTTON_CONTEST_SENT };
